import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import ScrollToTop from './components/ScrollToTop';
import './components/layout/Layout.css'; // Ensure layout styles are loaded

// Pages
import Home from './pages/Home';
import ThePlan from './pages/ThePlan';
import MythVsReality from './pages/MythVsReality';
import ShockTherapyLanding from './pages/ShockTherapyLanding';
import ShockTherapyArticle from './pages/ShockTherapyArticle';
import Issues from './pages/Issues';
import IssueArticle from './pages/IssueArticle';
import TheBill from './pages/TheBill';
import Calculator from './pages/Calculator';
import SafecareSimulator from './pages/SafecareSimulator';
import HealthInfrastructure from './pages/HealthInfrastructure';
import HowItWorks from './pages/HowItWorks';
import NotFound from './pages/NotFound';

import GoogleAnalytics from './components/GoogleAnalytics';

// Admin (dev only)
import AdminLayout from './admin/layout/AdminLayout';


function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <GoogleAnalytics />
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/plan" element={<Layout><ThePlan /></Layout>} />
        <Route path="/myth-vs-reality" element={<Layout><MythVsReality /></Layout>} />
        <Route path="/issues" element={<Layout><Issues /></Layout>} />
        <Route path="/issues/:id" element={<Layout><IssueArticle /></Layout>} />
        <Route path="/the-bill" element={<Layout><TheBill /></Layout>} />
        <Route path="/calculator" element={<Layout><Calculator /></Layout>} />
        <Route path="/simulator" element={<Layout><SafecareSimulator /></Layout>} />
        <Route path="/shock-therapy" element={<ShockTherapyLanding />} />
        <Route path="/shock-therapy/:articleId" element={<ShockTherapyArticle />} />
        <Route path="/infrastructure" element={<Layout><HealthInfrastructure /></Layout>} />
        <Route path="/how-it-works" element={<Layout><HowItWorks /></Layout>} />

        {/* Admin interface - development only */}
        {import.meta.env.DEV && (
          <Route path="/admin/*" element={<AdminLayout />} />
        )}

        {/* 404 Route - Must be last */}
        <Route path="*" element={<Layout><NotFound /></Layout>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
